export const socialAuthConfig = {
    google: {
        appId: process.env.REACT_APP_GOOGLE_APP_ID,
    },
    facebook: {
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
    },
}
